module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-group shadow"
  }, _vm._l((_vm.matchedItems), function(item, id) {
    return _c('vue-bootstrap-typeahead-list-item', {
      key: id,
      attrs: {
        "data": item.data,
        "html-text": _vm.highlight(item.text),
        "background-variant": _vm.backgroundVariant,
        "text-variant": _vm.textVariant
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleHit(item, $event)
        }
      }
    }, [(_vm.$scopedSlots.suggestion) ? _c('template', {
      attrs: {
        "slot-scope": "{ data, htmlText }"
      },
      slot: "suggestion"
    }, [_vm._t("suggestion", null, null, {
      data: _vm.data,
      htmlText: _vm.htmlText
    })], 2) : _vm._e()], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-900efda8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadList.vue
// module id = 1155
// module chunks = 5